import { Fragment } from 'react';
import Footer from './components/Footer/Footer';
import Header from './components/Header/Header';
import Router from './router/Router';
import './styles/layout.scss';
import './styles/media.scss';
import './styles/reset.css';
import './styles/font.scss';

function App() {
  return (
    <Fragment>
      <div className="wrap">
        <Header />
        <Router />
        <Footer />
      </div>
    </Fragment>
  );
}

export default App;
